/*eslint-disable*/
import { cloneDeep, camelCase } from 'lodash'
import trainerConfig from '../../config/trainer.json'

export function getGameType (slug) {
    let games = cloneDeep(trainerConfig.games);
    let gameSlug = slug === 'MultiplicationAndDivisionCourse' ? 'MultiplicationAndDivision' : slug;
    return camelCase(games.find(game => game.slug === gameSlug).courseType);
}
